// 不知道为什么 fireFox 的 composedPath 会返回空数组
export const composePath = (el: HTMLElement) => {
  const path = [];
  while (el) {
    path.push(el);

    if (el.tagName === 'HTML' || !el.parentElement) {
      path.push(document);
      path.push(window);

      return path;
    }
    el = el.parentElement;
  }
};
